import * as common from './common';

// Constants for URLS
const checkoutUrl = 'https://checkout.stage.minecraft.net';
const sisuUrl = 'https://sisu.xboxlive.com';
const accountServiceUrl = 'https://api-staging.mojang.com/';
const authServiceUrl = 'https://yggdrasil-auth-staging.mojang.com/';
const minecraftServicesUrl = 'https://api-staging.minecraftservices.com/';
const msaOAuthUrl = 'https://login.live.com/oauth20_logout.srf';
const creditCardServicesUrl = 'https://api-staging.minecraftservices.com';
const minecraftStageUrl = 'https://mc-stage.minecraft.net';
const migratePremiumUrl = 'https://account.mojang.com/migrate';
const microsoftAccountUrl = 'https://account.microsoft.com/';
const playfabAuth = 'https://auth-secondary.stage-8c721e1e.franchise.minecraft-services.net/api/v1.0/session/start';
const playfabEntitles = 'https://client.stage-dbac2842.store.minecraft-services.net/api/v1.0/player/playedtitles';
const xboxProfileUrl = 'https://profile.xboxlive.com';
const pocketRealmsUrl = 'https://bedrock.frontendlegacy.stage-c2a40e62.realms.minecraft-services.net/';
const pocketRealmsAccessTokenUrl = 'https://pocket-stage.realms.minecraft.net/';
const pocketRealmsJavaUrl = 'https://java.frontendlegacy.stage-c2a40e62.realms.minecraft-services.net/';
const originalPocketRealmsJavaUrl = 'https://pc-stage.realms.minecraft.net/';
const entitlementServiceUrl = 'https://entitlements.stage-b99582e8.mktpl.minecraft-services.net/api/v1.0';
const paymentServiceUrl = 'https://payments.stage-c2a40e62.realms.minecraft-services.net/api/v1.0';
const xboxPeopleHub = 'https://peoplehub.xboxlive.com/';
const discoveryURL = 'https://client.stage-b4c666a2.discovery.minecraft-services.net';
const netMinecraftServicesBaseUrl = 'https://net-secondary.stage-732c232f.web.minecraft-services.net';

export const sharedEnvConfig = (window.sharedEnvConfig = {
  ...common.sharedEnvConfig,
  ...window.sharedEnvConfig,
  'endpoint.accountsService': accountServiceUrl,
  'endpoint.authService': authServiceUrl,
  'endpoint.minecraftServices': minecraftServicesUrl,
  'endpoint.xboxAuthUrl': sisuUrl + '/connect/XboxLive/',
  'endpoint.xboxOAuthUrl': sisuUrl + '/connect/oauth/XboxLive/',
  'endpoint.msaOAuthUrl': msaOAuthUrl,
  'enable.msaMigration': true,
  'url.buyMinecraft': checkoutUrl + '/' + common.language + '/store/minecraft/#buy',
  'url.migratePremiumAccount': migratePremiumUrl,
  'url.register': checkoutUrl + '/' + common.language + '/store/minecraft/#register',
  'url.freeTrial': minecraftStageUrl + `/${common.language}/free-trial`, // Not being used currently and is added to avoid console errors
  'url.buyMinecraftJavaEdition': minecraftStageUrl + `/${common.language}/store/minecraft-java-edition`,
  'url.changeAccountSettings': microsoftAccountUrl,
  'url.setUpProfile': minecraftStageUrl + `/${common.language}/msaprofile/editprofile`,
  'enable.newProfile': true
});

window.accountNavMenuConfig = {
  ...common.accountNavMenuConfig,
  ...window.accountNavMenuConfig
};

window.answerSecurityQuestionsConfig = {
  ...common.answerSecurityQuestionsConfig,
  ...window.answerSecurityQuestionsConfig
};

export const bundleConfig = {
  ...sharedEnvConfig,
  ...common.bundleConfig,
  ...window.bundleConfig,
  whitelistedRedirectHosts: ['minecraft.net'],
  'url.redeem': minecraftStageUrl + `/${common.language}/redeem`,
  'enable.maintenanceView': false,
  'enable.linkAccountRoute': true,
  'url.billingInfoEditCardMyRealms':
    checkoutUrl + `/${common.language}/billing-info/?account_type=msa&callback_url=` + encodeURIComponent(minecraftStageUrl + `/${common.language}/msaprofile/myrealms`),
  'url.playfabAuth': playfabAuth,
  'url.playfabEntitles': playfabEntitles,
  playFabTitleId: 'E9358',
  'url.xboxProfile': xboxProfileUrl,
  'enable.javaRealms': true,
  'enable.bedrockRealms': true,
  'enable.postMigration': true,
  'url.pocketRealmsUrl': pocketRealmsUrl,
  'url.pocketRealmsJavaUrl': pocketRealmsJavaUrl,
  'url.originalPocketRealmsJavaUrl': originalPocketRealmsJavaUrl,
  'endpoint.entitlementService': entitlementServiceUrl,
  'endpoint.paymentService': paymentServiceUrl,
  'enable.onestoreWallet': true,
  'endpoint.creditCardService': creditCardServicesUrl,
  'url.xboxPeopleHubUrl': xboxPeopleHub,
  'url.discoveryService': discoveryURL,
  'toggle.OneStoreWallet.setProfileName.Flow': false,
  'endpoint.net.minecraftServices': netMinecraftServicesBaseUrl,
  environmentName: 'PPE'
};

window.buyMinecraftLoginConfig = {
  ...common.buyMinecraftLoginConfig,
  ...window.buyMinecraftLoginConfig
};

window.msaUtilsConfig = {
  ...common.msaUtilsConfig,
  environmentName: '',
  ...window.msaUtilsConfig,
  'url.pocketRelamsMinecraft': pocketRealmsAccessTokenUrl
};

window.cartStoreConfig = {
  ...common.cartStoreConfig,
  ...window.cartStoreConfig
};

window.loginConfig = {
  ...common.loginConfig,
  ...window.loginConfig
};

window.logoutConfig = {
  ...common.logoutConfig,
  xboxMSAClientId: 'ca634a9a-f102-4033-b081-3a4393a6f65d',
  ...window.logoutConfig
};

window.msaMigrationConfig = {
  ...common.msaMigrationConfig,
  ...window.msaMigrationConfig,
  'url.xboxUpsellReturnUrl': minecraftStageUrl + '/' + common.language + '/link-accounts'
};

window.msaRegistrationConfig = {
  ...common.msaRegistrationConfig,
  ...window.msaRegistrationConfig
};

window.orderSummaryConfig = {
  ...common.orderSummaryConfig,
  ...window.orderSummaryConfig
};

window.passwordChangeConfig = {
  ...common.passwordChangeConfig,
  ...window.passwordChangeConfig
};

window.passwordForgotConfig = {
  ...common.passwordForgotConfig,
  ...window.passwordForgotConfig
};

window.passwordResetConfig = {
  ...common.passwordResetConfig,
  ...window.passwordResetConfig
};

window.profileConfig = {
  ...common.profileConfig,
  ...window.profileConfig,
  /** Below URL's are not being used and present due to config console errors */
  'url.realmsTrialCC': checkoutUrl + `/${common.language}/realms-trial/`,
  'url.billingInfoAddCard': checkoutUrl + `/${common.language}/billing-info`,
  'url.billingInfoRemoveCard': checkoutUrl + `/${common.language}/billing-info?remove=true`,
  'url.restartUrl': minecraftStageUrl + `/${common.language}/profile/realms`,
  'url.orderSummaryUrl': minecraftStageUrl + `/${common.language}/msaprofile/wallet/buyrealms`
  /** End Unused  */
};

window.profileRedeemCodeConfig = {
  ...common.profileRedeemCodeConfig,
  ...window.profileRedeemCodeConfig
};

window.setProfileNameConfig = {
  ...common.setProfileNameConfig,
  ...window.setProfileNameConfig
};
